import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`


    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    html, body {
        width: 100vw;
        max-width: 100%;
        position: relative;
        scroll-behavior: auto;
        overflow-x: hidden;
        
    }

    body {
        font-family: 'PP Object Sans';
        background-color: ${({ theme }) => theme.colors.background.dark};
        scrollbar-color: #91d1f8 #4d81ee !important;
        color: ${({ theme }) => theme.colors.text.primary};
        line-height: 1.6;
    }

    a {
        text-decoration: none;
        color: inherit;
    }

    ul {
        list-style: none;
    }

    li {
        list-style: none;
    }
`;

export default GlobalStyles;
